var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1687_557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.6542 0.6682L0.668885 14.642C-0.0829877 15.3933 -0.0829877 16.6067 0.668885 17.3579L14.6542 31.3317C15.4061 32.083 16.6205 32.083 17.3723 31.3317L23.2362 25.4727C23.9095 24.7999 23.9095 23.7091 23.2362 23.0363C22.5628 22.3635 21.4711 22.3635 20.7977 23.0363L16.3524 27.4779C16.1653 27.6649 15.8812 27.6649 15.6941 27.4779L4.52584 16.3189C4.3387 16.1319 4.3387 15.8481 4.52584 15.6611L15.6941 4.50202C15.8812 4.31503 16.1653 4.31503 16.3524 4.50202L20.7977 8.94369C21.4711 9.61649 22.5628 9.61649 23.2362 8.94369C23.9095 8.27089 23.9095 7.18006 23.2362 6.50725L17.373 0.648875C16.618 -0.0861221 15.4032 -0.0801718 14.6542 0.6682Z",
    fill: "url(#paint0_linear_1687_557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M14.6542 0.6682L0.668885 14.642C-0.0829877 15.3933 -0.0829877 16.6067 0.668885 17.3579L14.6542 31.3317C15.4061 32.083 16.6205 32.083 17.3723 31.3317L23.2362 25.4727C23.9095 24.7999 23.9095 23.7091 23.2362 23.0363C22.5628 22.3635 21.4711 22.3635 20.7977 23.0363L16.3524 27.4779C16.1653 27.6649 15.8812 27.6649 15.6941 27.4779L4.52584 16.3189C4.3387 16.1319 4.3387 15.8481 4.52584 15.6611L15.6941 4.50202C16.1601 4.10031 16.9204 3.28665 18.0368 3.09635C18.8666 2.95492 19.7737 3.2662 20.7583 4.03019C20.1 3.3725 18.9716 2.2454 17.373 0.648875C16.618 -0.0861221 15.4032 -0.0801718 14.6542 0.6682Z",
    fill: "url(#paint1_linear_1687_557)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M24.5897 21.7366C25.263 22.4095 26.3547 22.4095 27.0281 21.7366L31.3536 17.4148C32.1054 16.6635 32.1054 15.4501 31.3536 14.6989L26.9905 10.3548C26.3155 9.68281 25.2235 9.68377 24.5497 10.357C23.8763 11.0298 23.8763 12.1206 24.5497 12.7934L27.4966 15.7379C27.6837 15.9249 27.6837 16.2087 27.4966 16.3957L24.5897 19.3002C23.9163 19.973 23.9163 21.0638 24.5897 21.7366Z",
    fill: "url(#paint2_linear_1687_557)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M16.0832 19.8427C18.1686 19.8427 19.8592 18.1535 19.8592 16.0698C19.8592 13.9861 18.1686 12.2969 16.0832 12.2969C13.9977 12.2969 12.3071 13.9861 12.3071 16.0698C12.3071 18.1535 13.9977 19.8427 16.0832 19.8427Z",
    fill: "url(#paint3_linear_1687_557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1687_557",
    x1: 14.7836,
    y1: 0.102235,
    x2: 28.0737,
    y2: 8.21829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1687_557",
    x1: 16.5662,
    y1: 0.102234,
    x2: 10.0021,
    y2: 34.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378601,
    stopColor: "#148EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1687_557",
    x1: 29.5313,
    y1: 8.24394,
    x2: 20.9904,
    y2: 21.6012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA816E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414726,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1687_557",
    x1: 17.4522,
    y1: 9.60372,
    x2: 14.6104,
    y2: 20.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512635,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1687_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyLogo);
export default __webpack_public_path__ + "static/media/only_Logo.b1315a77c05c4a13c0ce239426d5c141.svg";
export { ForwardRef as ReactComponent };